/**
 * sifremiUnuttumService.js — "Şifremi unuttum" sayfasının herkese açık ucu (backlog #570, backend #569).
 *
 * `POST /public/sifremi-unuttum` (`/api/v1`'in DIŞINDA, oturum istemez), gövde `{ kullanici }`: giriş adı YA DA e-posta adresi, yazıldığı gibi.
 * Cevap HER hesap için aynıdır (200 `{ mesaj, mesajKey }`): bilinmeyen, pasif, adresi olmayan ya da gerçekten e-posta giden bir hesabı
 * ayırt etmek mümkün değil, sayfa da ayırt etmeye çalışmaz. Diğer cevaplar hesaplarla ilgili bir şey söylemez:
 *   · 400 `sifre.unuttum_kullanici_gerekli` — hiçbir şey yazılmadı (ya da 255 karakterden uzun)
 *   · 429 `sifre.unuttum_cok_sik` — bir sınır aşıldı (yazılan ad başına saatte 3, adres başına 20, toplam 300); `Retry-After` saniye cinsinden
 *     (başlık tarayıcıya yalnızca backend `Access-Control-Expose-Headers` ile açarsa okunur: okunamazsa `retryAfter` null gelir)
 * Hata gövdesi `{ error, errorKey }` (PublicSifreController ile aynı). Yazılan ad adres çubuğuna yazılmaz, saklanmaz, konsola basılmaz.
 */
import axios from 'axios';
import { JAVA_BACKEND_ORIGIN, getPublicHeader } from '../Components/Contexts/BackendConstants';

const PUBLIC_URL = `${JAVA_BACKEND_ORIGIN}/public/sifremi-unuttum`;

function parseError(error) {
  const data = error.response?.data;
  const govde = data && typeof data === 'object' ? data : {};
  const wrapped = new Error(govde.error || error.message || 'Bilinmeyen hata');
  wrapped.status = error.response?.status ?? null;
  wrapped.errorKey = govde.errorKey || null;
  const bekle = Number(error.response?.headers?.['retry-after']);
  wrapped.retryAfter = Number.isFinite(bekle) && bekle > 0 ? bekle : null;
  throw wrapped;
}

/** POST /public/sifremi-unuttum `{ kullanici }` → `{ mesaj, mesajKey }` (hep aynı; bir hesap eşleşiyorsa e-posta gider, sayfa bunu bilmez). */
export async function sifremiUnuttumTalebi(kullanici) {
  try {
    const response = await axios.post(PUBLIC_URL, { kullanici }, { headers: getPublicHeader() });
    return response.data;
  } catch (error) {
    parseError(error);
  }
}
